export const LABEL_PROFILES = [
  { key: "spotify", label: "Spotify" },
  { key: "apple_music", label: "Apple Music" },
  { key: "beatport", label: "Beatport (pagina etichetta)" },
  { key: "traxsource", label: "Traxsource" },
  { key: "soundcloud", label: "SoundCloud" },
  { key: "youtube", label: "YouTube" },
  { key: "bandcamp", label: "Bandcamp" },
  { key: "deezer", label: "Deezer" },
  { key: "tidal", label: "Tidal" },
  { key: "amazon_music", label: "Amazon Music" },
  { key: "mixcloud", label: "Mixcloud" },
  { key: "resident_advisor", label: "Resident Advisor" },
  { key: "discogs", label: "Discogs" },
  { key: "musicbrainz", label: "MusicBrainz" },
  { key: "tiktok", label: "TikTok" },
  { key: "x", label: "X / Twitter" },
];

export const profileEntries = (settings) =>
  LABEL_PROFILES.map((p) => ({ ...p, url: settings?.profiles?.[p.key] })).filter((p) => p.url && p.url.startsWith("https://"));
